import { render, staticRenderFns } from "./sku_card.vue?vue&type=template&id=6c281561&scoped=true"
import script from "./sku_card.vue?vue&type=script&lang=js"
export * from "./sku_card.vue?vue&type=script&lang=js"
import style0 from "./sku_card.vue?vue&type=style&index=0&id=6c281561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c281561",
  null
  
)

export default component.exports